// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/v1/agent.proto (package infinigence.infini.agentplatform.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ChannelAccountBindingMode, ChannelType, ToolPermissions } from "./channel_pb.js";
import { file_agentplatform_v1_channel } from "./channel_pb.js";
import type { Param } from "./param_pb.js";
import { file_agentplatform_v1_param } from "./param_pb.js";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/v1/agent.proto.
 */
export const file_agentplatform_v1_agent: GenFile = /*@__PURE__*/
  fileDesc("ChxhZ2VudHBsYXRmb3JtL3YxL2FnZW50LnByb3RvEiNpbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MSKbCgoFQWdlbnQSMAoCaWQYASABKAlCJLpHIToQEg4iYWdlbnQtYWJjMTIzIpICDOi1hOa6kOe8luWPtxI4CgRuYW1lGAMgASgJQiq6Ryc6ExIRIuaIkeeahOaZuuiDveS9kyKSAg/mmbrog73kvZPlkI3np7ASVAoLZGVzY3JpcHRpb24YBCABKAlCP7pHPDooEiYi5LiA5Liq55So5LqO5a6i5pyN6Zeu562U55qE5pm66IO95L2TIpICD+aZuuiDveS9k+aPj+i/sBI9Cgl0ZW5hbnRfaWQYBSABKAlCH7pHHDoOEgwidGVuYW50LTAwMSKSAgnnp5/miLcgSURSCXRlbmFudF9pZBI3Cgd1c2VyX2lkGAYgASgJQh26Rxo6DBIKInVzZXItMDAxIpICCeeUqOaItyBJRFIHdXNlcl9pZBJNCg12aWJlX2FnZW50X2lkGAcgASgJQie6RyQ6EhIQInZpYmUtYWdlbnQtMDAxIpICDXZpYmUgYWdlbnQgSURSDXZpYmVfYWdlbnRfaWQSdgoMbW9kZWxfY29uZmlnGAggASgLMjUuaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuQWdlbnRNb2RlbENvbmZpZ0IbukcYkgIV5pm66IO95L2T5qih5Z6L6YWN572uUgxtb2RlbF9jb25maWcSfgoPY2hhbm5lbF9jb25maWdzGAkgAygLMjcuaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuQWdlbnRDaGFubmVsQ29uZmlnQhu6RxiSAhXmmbrog73kvZPmuKDpgZPphY3nva5SD2NoYW5uZWxfY29uZmlncxJ7Cg5wbHVnaW5fY29uZmlncxgKIAMoCzI2LmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLkFnZW50UGx1Z2luQ29uZmlnQhu6RxiSAhXmmbrog73kvZPmj5Lku7bphY3nva5SDnBsdWdpbl9jb25maWdzEn8KD2FkdmFuY2VkX2NvbmZpZxgLIAEoCzI4LmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLkFnZW50QWR2YW5jZWRDb25maWdCG7pHGJICFeaZuuiDveS9k+mrmOe6p+mFjee9rlIPYWR2YW5jZWRfY29uZmlnElcKCmNyZWF0ZWRfYXQYDCABKANCN7pHNDoMEgoxNzAwMDAwMDAwkgIb5Yib5bu65pe26Ze077yIZXBvY2gg56eS77yJmgIFaW50NjRSCmNyZWF0ZWRfYXQSVwoKdXBkYXRlZF9hdBgNIAEoA0I3ukc0OgwSCjE3MDAwMDAwMDCSAhvmm7TmlrDml7bpl7TvvIhlcG9jaCDnp5LvvImaAgVpbnQ2NFIKdXBkYXRlZF9hdBJXCgpkZWxldGVkX2F0GA4gASgDQje6RzQ6DBIKMTcwMDAwMDAwMJICG+WIoOmZpOaXtumXtO+8iGVwb2NoIOenku+8iZoCBWludDY0UgpkZWxldGVkX2F0EncKC2NvbmZpZ19oYXNoGA8gASgJQlW6R1I6DhIMImFiYzEyM2hhc2gikgI/6YWN572u5ZOI5biM77yM5Z+65LqOIGNvbmZpZ3VyYWJsZSDlj4LmlbDnmoQgbmFtZSt0YXJnZXQg55Sf5oiQUgtjb25maWdfaGFzaDoPukcMkgIJ5pm66IO95L2TIu8GChVBZ2VudE1vZGVsRXh0cmFDb25maWcSKAoLdGVtcGVyYXR1cmUYASABKAFCE7pHEDoFEgMwLjeSAgbmuKnluqYSQAoKbWF4X3Rva2VucxgCIAEoBUIgukcdOgYSBDIwNDiSAhLmnIDlpKfnlJ/miJDplb/luqZSCm1heF90b2tlbnMSUwoSbWF4X2NvbnRleHRfbGVuZ3RoGAMgASgFQiO6RyA6BhIEODE5MpICFeacgOWkp+S4iuS4i+aWh+mVv+W6plISbWF4X2NvbnRleHRfbGVuZ3RoEk8KD2VuYWJsZV90aGlua2luZxgEIAEoCEIgukcdOgYSBHRydWWSAhLmmK/lkKblkK/nlKjmgJ3ogINIAFIPZW5hYmxlX3RoaW5raW5niAEBEkUKEHByZXNlbmNlX3BlbmFsdHkYBSABKAFCGbpHFjoFEgMwLjCSAgzlrZjlnKjmg6nnvZpSEHByZXNlbmNlX3BlbmFsdHkSRwoRZnJlcXVlbmN5X3BlbmFsdHkYBiABKAFCGbpHFjoFEgMwLjCSAgzpopHnjofmg6nnvZpSEWZyZXF1ZW5jeV9wZW5hbHR5EsMCChByZWFzb25pbmdfZWZmb3J0GAggASgJQpECukeNAjoKEggibWVkaXVtIpIC/QHmgJ3ogIPnqIvluqYv5o6o55CG5by65bqm77yIdGhpbmtpbmcgbGV2ZWzvvInvvIzku4Xlr7nmlK/mjIHor6XnibnmgKfnmoTmjqjnkIbmqKHlnovnlJ/mlYjjgILlhbfkvZPlj6/nlKjlgLzlj5blhrPkuo7miYDpgInmqKHlnovvvIjlpoLpg6jliIbmqKHlnovmlK/mjIEgbWluaW1hbC9sb3cvbWVkaXVtL2hpZ2jvvIzpg6jliIbku4XmlK/mjIEgbG93L21lZGl1bS9oaWdo77yJ77yb5pyq6K6+572u5pe26Lef6ZqP5qih5Z6L6buY6K6k6KGM5Li6SAFSEHJlYXNvbmluZ19lZmZvcnSIAQE6IbpHHpICG+aZuuiDveS9k+aooeWei+mineWklumFjee9rkISChBfZW5hYmxlX3RoaW5raW5nQhMKEV9yZWFzb25pbmdfZWZmb3J0SgQIBxAIUhxzdXBwb3J0X2ludGVybGVhdmVkX3RoaW5raW5nIucEChBBZ2VudE1vZGVsQ29uZmlnEj0KCm1vZGVsX25hbWUYASABKAlCHbpHGjoJEgciZ3B0LTQikgIM5qih5Z6L5ZCN56ewUgptb2RlbF9uYW1lEjMKB2FwaV9rZXkYAiABKAlCGbpHFjoKEggic2steHh4IpICB0FQSSBLZXlSB2FwaV9rZXkSUwoNc3lzdGVtX3Byb21wdBgDIAEoCUItukcqOhYSFCLkvaDmmK/kuIDkuKrliqnmiYsikgIP5o+Q56S66K+N6YWN572uUg1zeXN0ZW1fcHJvbXB0EmgKDG1vZGVsX3BhcmFtcxgEIAMoCzIqLmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLlBhcmFtQhi6RxWSAhLmqKHlnovlj4LmlbDphY3nva5SDG1vZGVsX3BhcmFtcxKIAQoLYXBpX2tleV9yZWYYBSABKAlCZrpHYzoMEgoiY3JlZC0wMDEikgJSQVBJIEtleSDlvJXnlKgsIOS4jiBhcGlfa2V5IOS6jOmAieS4gO+8jOS8mOWFiCBhcGlfa2V5X3JlZu+8jCBhcGlfa2V5IOmAkOa4kOW8g+eUqFILYXBpX2tleV9yZWYSeAoMZXh0cmFfY29uZmlnGAYgASgLMjouaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuQWdlbnRNb2RlbEV4dHJhQ29uZmlnQhi6RxWSAhLmqKHlnovpop3lpJbphY3nva5SDGV4dHJhX2NvbmZpZzobukcYkgIV5pm66IO95L2T5qih5Z6L6YWN572uIrcDChJBZ2VudENoYW5uZWxDb25maWcShAEKDGNoYW5uZWxfdHlwZRgBIAEoDjIwLmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLkNoYW5uZWxUeXBlQi66Rys6GhIYQ0hBTk5FTF9UWVBFX1VOU1BFQ0lGSUVEkgIM5rig6YGT57G75Z6LUgxjaGFubmVsX3R5cGUSbAoOY2hhbm5lbF9wYXJhbXMYAiADKAsyKi5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MS5QYXJhbUIYukcVkgIS5rig6YGT6YWN572u5Y+C5pWwUg5jaGFubmVsX3BhcmFtcxKOAQoMYmluZGluZ19tb2RlGAMgASgOMj4uaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuQ2hhbm5lbEFjY291bnRCaW5kaW5nTW9kZUIqukcnOgoSCFRFTVBMQVRFkgIY5rig6YGT6LSm5Y+357uR5a6a5qih5byPUgxiaW5kaW5nX21vZGU6G7pHGJICFeaZuuiDveS9k+a4oOmBk+mFjee9riLNAgoRQWdlbnRQbHVnaW5Db25maWcSKQoEbmFtZRgBIAEoCUIbukcYOg0SCyJteV9wbHVnaW4ikgIG5ZCN56ewEj0KC3BsdWdpbl90eXBlGAIgASgJQhu6Rxg6BxIFIm1jcCKSAgzmj5Lku7bnsbvlnotSC3BsdWdpbl90eXBlEkUKCnBsdWdpbl91aWQYAyABKAlCJbpHIjoOEgwicGx1Z2luLTAwMSKSAg/mj5Lku7botYTmupBVSURSCnBsdWdpbl91aWQSagoNcGx1Z2luX3BhcmFtcxgEIAMoCzIqLmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLlBhcmFtQhi6RxWSAhLmj5Lku7bphY3nva7lj4LmlbBSDXBsdWdpbl9wYXJhbXM6G7pHGJICFeaZuuiDveS9k+aPkuS7tumFjee9riJaChFDb21wcmVzc2lvbkNvbmZpZxIxCgdlbmFibGVkGAEgASgIQiC6Rx06BhIEdHJ1ZZICEuaYr+WQpuWQr+eUqOWOi+e8qToSukcPkgIM5Y6L57yp6YWN572uIuICChBGaWxlc3lzdGVtQ29uZmlnEoEBCgZlbmFibGUYASABKAhCcbpHbpICa+aYr+WQpuWQr+eUqCBmaWxlc3lzdGVtIG1pZGRsZXdhcmXvvJvpu5jorqQgZmFsc2XvvIjkuI3lkK/nlKjvvInjgILlrZjph48gQWdlbnQg5peg5q2k5a2X5q615pe25LiN5byA5ZCv44CCEqUBCgV0b29scxgCIAMoDjIzLmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLkZpbGVzeXN0ZW1Ub29sQmG6R16SAlvlkK/nlKjnmoQgZmlsZXN5c3RlbSDlt6XlhbfliJfooajvvJvku4XlnKggZW5hYmxlPXRydWUg5pe255Sf5pWI77yM6buY6K6k5ZCv55So5omA5pyJ5bel5YW3OiK6Rx+SAhxmaWxlc3lzdGVtIG1pZGRsZXdhcmUg6YWN572uIrYCCg5Ub2RvTGlzdENvbmZpZxKAAQoGZW5hYmxlGAEgASgIQnC6R22SAmrmmK/lkKblkK/nlKggdG9kb19saXN0IG1pZGRsZXdhcmXvvJvpu5jorqQgZmFsc2XvvIjkuI3lkK/nlKjvvInjgILlrZjph48gQWdlbnQg5peg5q2k5a2X5q615pe25LiN5byA5ZCv44CCEn4KC2VuYWJsZV9kZXNjGAIgASgIQly6R1mSAlbmmK/lkKbkuLogVG9kbyDms6jlhaXpop3lpJbnmoQgZGVzY3JpcHRpb24g5a2X5q615byV5a+877yb5LuF5ZyoIGVuYWJsZT10cnVlIOaXtueUn+aViFILZW5hYmxlX2Rlc2M6IbpHHpICG3RvZG9fbGlzdCBtaWRkbGV3YXJlIOmFjee9riLWAgoNTW9kZWxGYWlsb3ZlchJKCgdlbmFibGVkGAEgASgIQjm6RzY6BxIFZmFsc2WSAirmmK/lkKblkK/nlKjmqKHlnosgZmFpbG92ZXLvvJvpu5jorqQgZmFsc2USuAEKDWJhY2t1cF9tb2RlbHMYAiADKAlCkQG6R40BkgKJAeWkh+eUqOaooeWei+axoO+8iOacieW6j++8ie+8mummlumAieS7jeS4uuWunuS+i+e7keWumueahOm7mOiupOaooeWei++8jOWksei0peWQjuaMieW6j+WIh+aNouOAguWkh+eUqOaooeWei+WkjeeUqOWunuS+i+iHqui6q+eahCBBUEkgS2V5Ug1iYWNrdXBfbW9kZWxzOj66RzuSAjjmqKHlnosgZmFpbG92ZXIg6YWN572u77yI5LuFIE1PREVMIOatpemqpOexu+Wei+acieaViO+8iSL7BQoOU3RlcFR5cGVQb2xpY3kSggEKCXN0ZXBfdHlwZRgBIAEoDjItLmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLlN0ZXBUeXBlQjW6RzI6BxIFTU9ERUySAibmraXpqqTnsbvlnovvvJpNT0RFTCAvIFRPT0wgLyBTVUJBR0VOVFIJc3RlcF90eXBlEnsKF2F0dGVtcHRfdGltZW91dF9zZWNvbmRzGAIgASgFQkG6Rz46BBICNjCSAjXljZXmrKHlsJ3or5XotoXml7bvvIjnp5LvvInvvIziiaQgNzJo77yIMjU5MjAwIOenku+8iVIXYXR0ZW1wdF90aW1lb3V0X3NlY29uZHMSWgoNcmV0cnlfZW5hYmxlZBgDIAEoCEI0ukcxOgYSBHRydWWSAibmmK/lkKblkK/nlKjmraXpqqTph43or5XvvJvpu5jorqQgdHJ1ZVINcmV0cnlfZW5hYmxlZBJYCgttYXhfcmV0cmllcxgEIAEoBUI2ukczOgMSATOSAivmnIDlpKfph43or5XmrKHmlbDvvIzojIPlm7QgMS0xMO+8jOm7mOiupCAzUgttYXhfcmV0cmllcxJxChZyZXRyeV9pbnRlcnZhbF9zZWNvbmRzGAUgASgFQjm6RzY6AxIBM5ICLumHjeivlemXtOmalO+8iOenku+8ie+8jOiMg+WbtCAxLTEw77yM6buY6K6kIDNSFnJldHJ5X2ludGVydmFsX3NlY29uZHMSmgEKDm1vZGVsX2ZhaWxvdmVyGAYgASgLMjIuaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuTW9kZWxGYWlsb3ZlckI+ukc7kgI45qih5Z6LIGZhaWxvdmVyIOmFjee9ru+8iOS7hSBNT0RFTCDmraXpqqTnsbvlnovmnInmlYjvvIlSDm1vZGVsX2ZhaWxvdmVyOiG6Rx6SAhvmraXpqqTnsbvlnovnuqflrrnplJnnrZbnlaUi7gEKElN0ZXBGYXVsdFRvbGVyYW5jZRJICgdlbmFibGVkGAEgASgIQje6RzQ6BhIEdHJ1ZZICKeaYr+WQpuWQr+eUqOatpemqpOe6p+WuuemUme+8m+m7mOiupCB0cnVlEncKCHBvbGljaWVzGAIgAygLMjMuaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuU3RlcFR5cGVQb2xpY3lCMLpHLZICKuaMieatpemqpOexu+Wei+eLrOeri+mFjee9rueahOWuuemUmeetlueVpToVukcSkgIP5q2l6aqk57qn5a656ZSZIrQEChJUYXNrRmF1bHRUb2xlcmFuY2USSAoHZW5hYmxlZBgBIAEoCEI3ukc0OgYSBHRydWWSAinmmK/lkKblkK/nlKjku7vliqHnuqflrrnplJnvvJvpu5jorqQgdHJ1ZRJ3ChV0b3RhbF90aW1lb3V0X3NlY29uZHMYAiABKAVCQbpHPjoGEgQxODAwkgIz5Lu75Yqh5oC76LaF5pe277yI56eS77yJ77yM4omkIDE2OGjvvIg2MDQ4MDAg56eS77yJUhV0b3RhbF90aW1lb3V0X3NlY29uZHMSdwoNcmV0cnlfZW5hYmxlZBgDIAEoCEJRukdOOgcSBWZhbHNlkgJC5Lu75Yqh6Ieq5Yqo6YeN6K+V77yI5LuO5a6J5YWoIGNoZWNrcG9pbnQg5oGi5aSN77yJ77yb6buY6K6kIGZhbHNlUg1yZXRyeV9lbmFibGVkElgKC21heF9yZXRyaWVzGAQgASgFQja6RzM6AxIBM5ICK+acgOWkp+mHjeivleasoeaVsO+8jOiMg+WbtCAxLTEw77yM6buY6K6kIDNSC21heF9yZXRyaWVzEnEKFnJldHJ5X2ludGVydmFsX3NlY29uZHMYBSABKAVCObpHNjoDEgEzkgIu6YeN6K+V6Ze06ZqU77yI56eS77yJ77yM6IyD5Zu0IDEtMTDvvIzpu5jorqQgM1IWcmV0cnlfaW50ZXJ2YWxfc2Vjb25kczoVukcSkgIP5Lu75Yqh57qn5a656ZSZItwBCg1Bc2tVc2VyQ29uZmlnEn8KBmVuYWJsZRgBIAEoCEJvukdskgJp5piv5ZCm5ZCv55SoIGFza191c2VyIG1pZGRsZXdhcmXvvJvpu5jorqQgZmFsc2XvvIjkuI3lkK/nlKjvvInjgILlrZjph48gQWdlbnQg5peg5q2k5a2X5q615pe25LiN5byA5ZCv44CCOkq6R0eSAkRhc2tfdXNlciBtaWRkbGV3YXJlIOmFjee9ru+8iOWQkeeUqOaIt+aPkOmXrueahOS6uuW3peS7i+WFpeW3peWFt++8iSKLAgoVUmVhZEJlZm9yZVdyaXRlQ29uZmlnEqUBCgZlbmFibGUYASABKAhClAG6R5ABkgKMAeaYr+WQpuWQr+eUqCByZWFkX2JlZm9yZV93cml0ZSBtaWRkbGV3YXJl77yb6buY6K6kIGZhbHNl77yI5LiN5ZCv55So77yJ44CC5ZCv55So5ZCO5a+55bey5a2Y5Zyo5paH5Lu255qE5YaZ5pON5L2c6KaB5rGC5YWI6K+76L+H5b2T5YmN54mI5pysOkq6R0eSAkRyZWFkX2JlZm9yZV93cml0ZSBtaWRkbGV3YXJlIOmFjee9ru+8iOWGmeWJjeW/hemhu+ivu+eJiOacrOmXqOaOp++8iSLKAwoPV2ViU2VhcmNoQ29uZmlnEoEBCgZlbmFibGUYASABKAhCcbpHbpICa+aYr+WQpuWQr+eUqCB3ZWJfc2VhcmNoIG1pZGRsZXdhcmXvvJvpu5jorqQgZmFsc2XvvIjkuI3lkK/nlKjvvInjgILlrZjph48gQWdlbnQg5peg5q2k5a2X5q615pe25LiN5byA5ZCv44CCEmIKDnRhdmlseV9hcGlfa2V5GAIgASgJQjq6Rzc6DBIKInR2bHkteHh4IpICJlRhdmlseSBBUEkgS2V577ybZW5hYmxlPXRydWUg5pe25b+F5aGrUg50YXZpbHlfYXBpX2tleRJ9CgttYXhfcmVzdWx0cxgDIAEoBUJbukdYOgMSATWSAlDljZXmrKHmkJzntKLov5Tlm57nmoTmnIDlpKfnu5PmnpzmlbDvvJswIOaIlue8uuecgeaXtueUsSBmcmFtZXdvcmsg6buY6K6k77yINe+8iVILbWF4X3Jlc3VsdHM6ULpHTZICSndlYl9zZWFyY2ggbWlkZGxld2FyZSDphY3nva7vvIhUYXZpbHkg6IGU572R5pCc57SiICsg572R6aG15oqT5Y+W5bel5YW377yJIrUFChRGYXVsdFRvbGVyYW5jZUNvbmZpZxKTAQoHZW5hYmxlZBgBIAEoCEKBAbpHfjoGEgR0cnVlkgJz5a656ZSZ5oC75byA5YWz77yb6buY6K6kIHRydWXjgILnvLrnnIHvvIjlrZjph48gQWdlbnTvvInml7blubPlj7DkuI3kuIvlj5HlrrnplJkgbWlkZGxld2FyZe+8jOi/kOihjOaXtuihjOS4uuS4jeWPmBJcCgR0YXNrGAIgASgLMjcuaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuVGFza0ZhdWx0VG9sZXJhbmNlQhW6RxKSAg/ku7vliqHnuqflrrnplJkSXAoEc3RlcBgDIAEoCzI3LmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLlN0ZXBGYXVsdFRvbGVyYW5jZUIVukcSkgIP5q2l6aqk57qn5a656ZSZEmgKDGNvbmZpZ3VyYWJsZRgEIAEoCEJSukdPOgcSBWZhbHNlkgJD5piv5ZCm5byA5pS+57uZ5a6e5L6L6KaG55uW77yI6LWwIGluc3RhbmNlX3BhcmFtc++8ie+8m+m7mOiupCBmYWxzZRJ8ChNjb25maWd1cmFibGVfcGFyYW1zGAUgAygLMiouaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuUGFyYW1CHrpHG5ICGOeUqOS6juWunuS+i+imhueblumFjee9rlITY29uZmlndXJhYmxlX3BhcmFtczpjukdgkgJd5a656ZSZ6YWN572u77ya5Lu/54Wn5Y6L57yp6YWN572u5oyC5ZyoIEFnZW50QWR2YW5jZWRDb25maWcg5LiL77yManNvbmIg5a2Y5YKo44CBcHJvdG8g6YCP5LygIukBChFDdXJyZW50VGltZUNvbmZpZxKDAQoGZW5hYmxlGAEgASgIQnO6R3CSAm3mmK/lkKblkK/nlKggY3VycmVudF90aW1lIG1pZGRsZXdhcmXvvJvpu5jorqQgZmFsc2XvvIjkuI3lkK/nlKjvvInjgILlrZjph48gQWdlbnQg5peg5q2k5a2X5q615pe25LiN5byA5ZCv44CCOk66R0uSAkhjdXJyZW50X3RpbWUgbWlkZGxld2FyZSDphY3nva7vvIjmr4/mrKHmqKHlnovosIPnlKjov73liqDlvZPliY3ml7bpl7TvvIkiwwEKDEhJVExBcmdNYXRjaBI4Cghhcmd1bWVudBgBIAEoCUImukcjkgIg5bel5YW35Y+C5pWw5ZCN77yI5aaCIGNvbW1hbmTvvIkSRQoHcGF0dGVybhgCIAEoCUI0ukcxOggSBiJybS4qIpICJOWPguaVsOWAvOmcgOWMuemFjeeahOato+WImeihqOi+vuW8jzoyukcvkgIsSElUTCDlj4LmlbDljLnphY3mnaHku7bvvJrlj4LmlbDlkI0gKyDmraPliJkikAIKDUhJVExUb29sTWF0Y2gSQAoFdG9vbHMYASADKAlCMbpHLpICK+W3peWFt+WQjeWIl+ihqO+8iCIqIiDljLnphY3lhajpg6jlt6XlhbfvvIkSdwoEd2hlbhgCIAMoCzIxLmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLkhJVExBcmdNYXRjaEI2ukczkgIw5Y+C5pWw5Yy56YWN5p2h5Lu277yI5YWo6YOo5ruh6Laz5omN566X5ZG95Lit77yJOkS6R0GSAj5ISVRMIOW3peWFt+WMuemFjeadoeS7tu+8muW3peWFt+WQjeWIl+ihqCArIOWPr+mAieWPguaVsOadoeS7tiKpAwoQSElUTEFwcHJvdmFsUnVsZRJNCgZhY3Rpb24YASABKAlCPbpHOpICN+WRveS4reWQjueahOWKqOS9nDogZGVueSB8IGF1dG9fYXBwcm92ZSB8IHJlcXVpcmVfaHVtYW4SJwoLZGVzY3JpcHRpb24YAiABKAlCErpHD5ICDOinhOWImeaPj+i/sBJ4Cg9hbGxvd2VkX2FjdGlvbnMYAyADKAlCTrpHS5ICSOWFgeiuuOeahOS6uuW3peWGs+etluWKqOS9nO+8iOWmgiByZXNwb25k77yM55So5LqOIGFza191c2VyIOexu+S6pOS6ku+8iVIPYWxsb3dlZF9hY3Rpb25zEmwKCnRvb2xfbWF0Y2gYBCABKAsyMi5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MS5ISVRMVG9vbE1hdGNoQhi6RxWSAhLlt6XlhbfljLnphY3mnaHku7ZSCnRvb2xfbWF0Y2g6NbpHMpICL0hJVEwg5a6h5om56KeE5YiZ77ya5Yqo5L2cICsg5bel5YW35Yy56YWN5p2h5Lu2ItkFChRISVRMTWlkZGxld2FyZUNvbmZpZxJsCgdlbmFibGVkGAEgASgIQlu6R1iSAlXmmK/lkKblkK/nlKjvvIhmcmFtZXdvcmsgRmVhdHVyZUdhdGUg6buY6K6kIGZhbHNl77yM6ZyA5pi+5byP5byA5ZCv5omN5Lya5a6e5L6L5YyW77yJEnQKDmRlZmF1bHRfYWN0aW9uGAIgASgJQky6R0mSAkbml6Dop4TliJnlkb3kuK3ml7bnmoTpu5jorqTooYzkuLo6IHJlcXVpcmVfaHVtYW4gfCBkZW55IHwgYXV0b19hcHByb3ZlUg5kZWZhdWx0X2FjdGlvbhKTAQoFcnVsZXMYAyADKAsyNS5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MS5ISVRMQXBwcm92YWxSdWxlQk26R0qSAkflrqHmibnop4TliJnliJfooajvvIjlhYjljLnphY3lhYjnlJ/mlYjvvIxkZW55IOinhOWImeW6lOaOkuWcqOWJjemdou+8iRJsCgtlbmFibGVfZGVzYxgEIAEoCEJKukdHkgJE6Kem5Y+R5Lq65bel5a6h5om55pe25piv5ZCm6LCD55SoIExMTSDnlJ/miJDkuIDlj6XkuK3mlofmhI/lm77mj4/ov7BSC2VuYWJsZV9kZXNjEoIBCgpkZXNjX21vZGVsGAUgASgJQmK6R186FRITImRlZXBzZWVrLXY0LWZsYXNoIpICReaEj+WbvuaPj+i/sOS9v+eUqOeahOaooeWei+WQje+8jOeVmeepuuS9v+eUqCB2aWJlLWFnZW50IOm7mOiupOaooeWei1IKZGVzY19tb2RlbDpUukdRkgJOSElUTCDlrqHmibkgbWlkZGxld2FyZSDphY3nva7vvIh2aWJlLWFnZW50IEhJVExNaWRkbGV3YXJlQ29uZmlnIHdpcmUg5aWR57qm77yJIu8LChNBZ2VudEFkdmFuY2VkQ29uZmlnEl8KC2NvbXByZXNzaW9uGAEgASgLMjYuaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuQ29tcHJlc3Npb25Db25maWdCErpHD5ICDOWOi+e8qemFjee9rhK4AQoQdG9vbF9wZXJtaXNzaW9ucxgCIAEoCzI0LmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLlRvb2xQZXJtaXNzaW9uc0JWukdTkgJQ5bel5YW35p2D6ZmQ6KeE5YiZ77yIQWdlbnQg57qn5Yir77yJ77yM5LyY5YWI57qn6auY5LqOIENoYW5uZWxVc2VyQmluZGluZyDnuqfliKtSEHRvb2xfcGVybWlzc2lvbnMSlgEKEXNhbmRib3hfbWljcm9fYXBwGAMgASgJQmi6R2U6DRILIm15X3BsdWdpbiKSAlPmspnnrrHlvq7lupTnlKjlip/og73vvIzpgInmi6nmjIflrpogUGx1Z2luIOeahOaymeeuse+8jOS9nOS4uuW+ruW6lOeUqOi/kOihjOeOr+Wig1IRc2FuZGJveF9taWNyb19hcHASbQoKZmlsZXN5c3RlbRgEIAEoCzI1LmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLkZpbGVzeXN0ZW1Db25maWdCIrpHH5ICHGZpbGVzeXN0ZW0gbWlkZGxld2FyZSDphY3nva4SdAoJdG9kb19saXN0GAUgASgLMjMuaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuVG9kb0xpc3RDb25maWdCIbpHHpICG3RvZG9fbGlzdCBtaWRkbGV3YXJlIOmFjee9rlIJdG9kb19saXN0EpoBCghhc2tfdXNlchgGIAEoCzIyLmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLkFza1VzZXJDb25maWdCSrpHR5ICRGFza191c2VyIG1pZGRsZXdhcmUg6YWN572u77yI5ZCR55So5oi35o+Q6Zeu55qE5Lq65bel5LuL5YWl5bel5YW377yJUghhc2tfdXNlchK0AQoRcmVhZF9iZWZvcmVfd3JpdGUYByABKAsyOi5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MS5SZWFkQmVmb3JlV3JpdGVDb25maWdCSrpHR5ICRHJlYWRfYmVmb3JlX3dyaXRlIG1pZGRsZXdhcmUg6YWN572u77yI5YaZ5YmN5b+F6aG76K+754mI5pys6Zeo5o6n77yJUhFyZWFkX2JlZm9yZV93cml0ZRKmAQoKd2ViX3NlYXJjaBgIIAEoCzI0LmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLldlYlNlYXJjaENvbmZpZ0JQukdNkgJKd2ViX3NlYXJjaCBtaWRkbGV3YXJlIOmFjee9ru+8iFRhdmlseSDogZTnvZHmkJzntKIgKyDnvZHpobXmipPlj5blt6XlhbfvvIlSCndlYl9zZWFyY2gSqgEKDGN1cnJlbnRfdGltZRgJIAEoCzI2LmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLkN1cnJlbnRUaW1lQ29uZmlnQk66R0uSAkhjdXJyZW50X3RpbWUgbWlkZGxld2FyZSDphY3nva7vvIjmr4/mrKHmqKHlnovosIPnlKjov73liqDlvZPliY3ml7bpl7TvvIlSDGN1cnJlbnRfdGltZRJ3Cg9mYXVsdF90b2xlcmFuY2UYCiABKAsyOS5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MS5GYXVsdFRvbGVyYW5jZUNvbmZpZ0ISukcPkgIM5a656ZSZ6YWN572uUg9mYXVsdF90b2xlcmFuY2U6G7pHGJICFeaZuuiDveS9k+mrmOe6p+mFjee9riqUAgoORmlsZXN5c3RlbVRvb2wSHwobRklMRVNZU1RFTV9UT09MX1VOU1BFQ0lGSUVEEAASFgoSRklMRVNZU1RFTV9UT09MX0xTEAESHQoZRklMRVNZU1RFTV9UT09MX1JFQURfRklMRRACEh4KGkZJTEVTWVNURU1fVE9PTF9XUklURV9GSUxFEAMSHQoZRklMRVNZU1RFTV9UT09MX0VESVRfRklMRRAEEhoKFkZJTEVTWVNURU1fVE9PTF9ERUxFVEUQBRIYChRGSUxFU1lTVEVNX1RPT0xfR0xPQhAGEhgKFEZJTEVTWVNURU1fVE9PTF9HUkVQEAcSGwoXRklMRVNZU1RFTV9UT09MX0VYRUNVVEUQCCpICghTdGVwVHlwZRIZChVTVEVQX1RZUEVfVU5TUEVDSUZJRUQQABIJCgVNT0RFTBABEggKBFRPT0wQAhIMCghTVUJBR0VOVBADQklaR2dpdGxhYi5pbmZpbmktYWkuY29tL21pemFyL2luZmluaWFpLWFnZW50aWMtaW5mcmEvY29tbW9uL2dycGNhcGlzL3YxO3YxYgZwcm90bzM", [file_agentplatform_v1_channel, file_agentplatform_v1_param, file_gnostic_openapi_v3_annotations]);

/**
 * 定义智能体
 *
 * @generated from message infinigence.infini.agentplatform.v1.Agent
 */
export type Agent = Message<"infinigence.infini.agentplatform.v1.Agent"> & {
  /**
   * 资源编号
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 智能体名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 智能体描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 租户 ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 5 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户 ID
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 6 [json_name = "user_id"];
   */
  userId: string;

  /**
   * vibe agent ID
   * @gotags: json:"vibe_agent_id,omitempty"
   *
   * @generated from field: string vibe_agent_id = 7 [json_name = "vibe_agent_id"];
   */
  vibeAgentId: string;

  /**
   * 智能体模型配置
   * @gotags: json:"model_config,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.AgentModelConfig model_config = 8 [json_name = "model_config"];
   */
  modelConfig?: AgentModelConfig | undefined;

  /**
   * 智能体渠道配置
   * @gotags: json:"channel_configs,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.AgentChannelConfig channel_configs = 9 [json_name = "channel_configs"];
   */
  channelConfigs: AgentChannelConfig[];

  /**
   * 智能体插件配置
   * @gotags: json:"plugin_configs,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.AgentPluginConfig plugin_configs = 10 [json_name = "plugin_configs"];
   */
  pluginConfigs: AgentPluginConfig[];

  /**
   * 智能体高级配置
   * @gotags: json:"advanced_config,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.AgentAdvancedConfig advanced_config = 11 [json_name = "advanced_config"];
   */
  advancedConfig?: AgentAdvancedConfig | undefined;

  /**
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 12 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 13 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 14 [json_name = "deleted_at"];
   */
  deletedAt: bigint;

  /**
   * 配置哈希，基于 configurable 参数的 name+target 生成
   * @gotags: json:"config_hash,omitempty"
   *
   * @generated from field: string config_hash = 15 [json_name = "config_hash"];
   */
  configHash: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.Agent.
 * Use `create(AgentSchema)` to create a new message.
 */
export const AgentSchema: GenMessage<Agent> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 0);

/**
 * 智能体模型额外配置
 *
 * @generated from message infinigence.infini.agentplatform.v1.AgentModelExtraConfig
 */
export type AgentModelExtraConfig = Message<"infinigence.infini.agentplatform.v1.AgentModelExtraConfig"> & {
  /**
   * 温度
   * @gotags: json:"temperature,omitempty"
   *
   * @generated from field: double temperature = 1;
   */
  temperature: number;

  /**
   * 最大生成长度
   * @gotags: json:"max_tokens,omitempty"
   *
   * @generated from field: int32 max_tokens = 2 [json_name = "max_tokens"];
   */
  maxTokens: number;

  /**
   * 最大上下文长度
   * @gotags: json:"max_context_length,omitempty"
   *
   * @generated from field: int32 max_context_length = 3 [json_name = "max_context_length"];
   */
  maxContextLength: number;

  /**
   * 是否启用思考
   * @gotags: json:"enable_thinking,omitempty"
   *
   * @generated from field: optional bool enable_thinking = 4 [json_name = "enable_thinking"];
   */
  enableThinking?: boolean | undefined;

  /**
   * 存在惩罚
   * @gotags: json:"presence_penalty,omitempty"
   *
   * @generated from field: double presence_penalty = 5 [json_name = "presence_penalty"];
   */
  presencePenalty: number;

  /**
   * 频率惩罚
   * @gotags: json:"frequency_penalty,omitempty"
   *
   * @generated from field: double frequency_penalty = 6 [json_name = "frequency_penalty"];
   */
  frequencyPenalty: number;

  /**
   * 思考程度 / 推理强度 (reasoning_effort)。
   * 对齐 framework LangGraphLLMConfig.reasoning_effort：
   * 仅对支持推理分档的模型生效，具体支持的可选值取决于所选模型能力（例如部分模型支持 minimal/low/medium/high，部分仅支持 low/medium/high）；未设置时为 None（跟随模型默认行为）。
   * 对应产品侧概念: thinking level。
   * @gotags: json:"reasoning_effort,omitempty"
   *
   * @generated from field: optional string reasoning_effort = 8 [json_name = "reasoning_effort"];
   */
  reasoningEffort?: string | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.AgentModelExtraConfig.
 * Use `create(AgentModelExtraConfigSchema)` to create a new message.
 */
export const AgentModelExtraConfigSchema: GenMessage<AgentModelExtraConfig> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 1);

/**
 * 智能体模型配置
 *
 * @generated from message infinigence.infini.agentplatform.v1.AgentModelConfig
 */
export type AgentModelConfig = Message<"infinigence.infini.agentplatform.v1.AgentModelConfig"> & {
  /**
   * 模型名称
   * @gotags: json:"model_name,omitempty"
   *
   * @generated from field: string model_name = 1 [json_name = "model_name"];
   */
  modelName: string;

  /**
   * API Key
   * @gotags: json:"api_key,omitempty"
   *
   * @generated from field: string api_key = 2 [json_name = "api_key"];
   */
  apiKey: string;

  /**
   * 提示词配置
   * @gotags: json:"system_prompt,omitempty"
   *
   * @generated from field: string system_prompt = 3 [json_name = "system_prompt"];
   */
  systemPrompt: string;

  /**
   * 模型参数配置
   * @gotags: json:"model_params,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Param model_params = 4 [json_name = "model_params"];
   */
  modelParams: Param[];

  /**
   * API Key 引用, 与 api_key 二选一，优先 api_key_ref， api_key 逐渐弃用
   * @gotags: json:"api_key_ref,omitempty"
   *
   * @generated from field: string api_key_ref = 5 [json_name = "api_key_ref"];
   */
  apiKeyRef: string;

  /**
   * 模型额外配置
   * @gotags: json:"extra_config,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.AgentModelExtraConfig extra_config = 6 [json_name = "extra_config"];
   */
  extraConfig?: AgentModelExtraConfig | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.AgentModelConfig.
 * Use `create(AgentModelConfigSchema)` to create a new message.
 */
export const AgentModelConfigSchema: GenMessage<AgentModelConfig> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 2);

/**
 * 智能体渠道配置
 *
 * @generated from message infinigence.infini.agentplatform.v1.AgentChannelConfig
 */
export type AgentChannelConfig = Message<"infinigence.infini.agentplatform.v1.AgentChannelConfig"> & {
  /**
   * @gotags: json:"channel_type,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelType channel_type = 1 [json_name = "channel_type"];
   */
  channelType: ChannelType;

  /**
   * 渠道配置参数
   * @gotags: json:"channel_params,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Param channel_params = 2 [json_name = "channel_params"];
   */
  channelParams: Param[];

  /**
   * 渠道账号绑定模式
   * @gotags: json:"binding_mode,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelAccountBindingMode binding_mode = 3 [json_name = "binding_mode"];
   */
  bindingMode: ChannelAccountBindingMode;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.AgentChannelConfig.
 * Use `create(AgentChannelConfigSchema)` to create a new message.
 */
export const AgentChannelConfigSchema: GenMessage<AgentChannelConfig> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 3);

/**
 * 智能体插件配置
 *
 * @generated from message infinigence.infini.agentplatform.v1.AgentPluginConfig
 */
export type AgentPluginConfig = Message<"infinigence.infini.agentplatform.v1.AgentPluginConfig"> & {
  /**
   * 名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 插件类型
   * @gotags: json:"plugin_type,omitempty"
   *
   * @generated from field: string plugin_type = 2 [json_name = "plugin_type"];
   */
  pluginType: string;

  /**
   * 插件资源UID
   * @gotags: json:"plugin_uid,omitempty"
   *
   * @generated from field: string plugin_uid = 3 [json_name = "plugin_uid"];
   */
  pluginUid: string;

  /**
   * 插件配置参数
   * @gotags: json:"plugin_params,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Param plugin_params = 4 [json_name = "plugin_params"];
   */
  pluginParams: Param[];
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.AgentPluginConfig.
 * Use `create(AgentPluginConfigSchema)` to create a new message.
 */
export const AgentPluginConfigSchema: GenMessage<AgentPluginConfig> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 4);

/**
 * 压缩配置
 *
 * @generated from message infinigence.infini.agentplatform.v1.CompressionConfig
 */
export type CompressionConfig = Message<"infinigence.infini.agentplatform.v1.CompressionConfig"> & {
  /**
   * 是否启用压缩：启用后下发 deepagent summarization + summarization tool 中间件，
   * 摘要模型默认复用主 Agent LLM，无需额外配置。
   * @gotags: json:"enabled,omitempty"
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.CompressionConfig.
 * Use `create(CompressionConfigSchema)` to create a new message.
 */
export const CompressionConfigSchema: GenMessage<CompressionConfig> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 5);

/**
 * filesystem middleware 配置
 *
 * @generated from message infinigence.infini.agentplatform.v1.FilesystemConfig
 */
export type FilesystemConfig = Message<"infinigence.infini.agentplatform.v1.FilesystemConfig"> & {
  /**
   * 是否启用 filesystem middleware；默认 false（不启用）。存量 Agent 无此字段时不开启。
   * 创建页面前端开关默认可勾选，提交时写入 true。
   * @gotags: json:"enable,omitempty"
   *
   * @generated from field: bool enable = 1;
   */
  enable: boolean;

  /**
   * 启用的 filesystem 工具列表；仅在 enable=true 时生效，为空时由运行时默认决定
   * @gotags: json:"tools,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.FilesystemTool tools = 2;
   */
  tools: FilesystemTool[];
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.FilesystemConfig.
 * Use `create(FilesystemConfigSchema)` to create a new message.
 */
export const FilesystemConfigSchema: GenMessage<FilesystemConfig> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 6);

/**
 * todo_list middleware 配置
 *
 * @generated from message infinigence.infini.agentplatform.v1.TodoListConfig
 */
export type TodoListConfig = Message<"infinigence.infini.agentplatform.v1.TodoListConfig"> & {
  /**
   * 是否启用 todo_list middleware；默认 false（不启用）。存量 Agent 无此字段时不开启。
   * @gotags: json:"enable,omitempty"
   *
   * @generated from field: bool enable = 1;
   */
  enable: boolean;

  /**
   * 是否为 Todo 注入额外的 description 字段引导；仅在 enable=true 时生效
   * @gotags: json:"enable_desc,omitempty"
   *
   * @generated from field: bool enable_desc = 2 [json_name = "enable_desc"];
   */
  enableDesc: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.TodoListConfig.
 * Use `create(TodoListConfigSchema)` to create a new message.
 */
export const TodoListConfigSchema: GenMessage<TodoListConfig> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 7);

/**
 * 模型 failover 配置（仅 MODEL 步骤类型有效）
 *
 * @generated from message infinigence.infini.agentplatform.v1.ModelFailover
 */
export type ModelFailover = Message<"infinigence.infini.agentplatform.v1.ModelFailover"> & {
  /**
   * 是否启用模型 failover；默认 false
   * @gotags: json:"enabled,omitempty"
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * 备用模型池（有序）：首选仍为实例绑定的默认模型，失败后按序切换。备用模型复用实例自身的 API Key
   * @gotags: json:"backup_models,omitempty"
   *
   * @generated from field: repeated string backup_models = 2 [json_name = "backup_models"];
   */
  backupModels: string[];
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.ModelFailover.
 * Use `create(ModelFailoverSchema)` to create a new message.
 */
export const ModelFailoverSchema: GenMessage<ModelFailover> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 8);

/**
 * 步骤类型级容错策略
 *
 * @generated from message infinigence.infini.agentplatform.v1.StepTypePolicy
 */
export type StepTypePolicy = Message<"infinigence.infini.agentplatform.v1.StepTypePolicy"> & {
  /**
   * 步骤类型：MODEL / TOOL / SUBAGENT
   * @gotags: json:"step_type,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.StepType step_type = 1 [json_name = "step_type"];
   */
  stepType: StepType;

  /**
   * 单次尝试超时（秒），≤ 72h（259200 秒）
   * @gotags: json:"attempt_timeout_seconds,omitempty"
   *
   * @generated from field: int32 attempt_timeout_seconds = 2 [json_name = "attempt_timeout_seconds"];
   */
  attemptTimeoutSeconds: number;

  /**
   * 是否启用步骤重试；默认 true
   * @gotags: json:"retry_enabled,omitempty"
   *
   * @generated from field: bool retry_enabled = 3 [json_name = "retry_enabled"];
   */
  retryEnabled: boolean;

  /**
   * 最大重试次数，范围 1-10，默认 3
   * @gotags: json:"max_retries,omitempty"
   *
   * @generated from field: int32 max_retries = 4 [json_name = "max_retries"];
   */
  maxRetries: number;

  /**
   * 重试间隔（秒），范围 1-10，默认 3
   * @gotags: json:"retry_interval_seconds,omitempty"
   *
   * @generated from field: int32 retry_interval_seconds = 5 [json_name = "retry_interval_seconds"];
   */
  retryIntervalSeconds: number;

  /**
   * 模型 failover 配置（仅 MODEL 步骤类型有效）
   * @gotags: json:"model_failover,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ModelFailover model_failover = 6 [json_name = "model_failover"];
   */
  modelFailover?: ModelFailover | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.StepTypePolicy.
 * Use `create(StepTypePolicySchema)` to create a new message.
 */
export const StepTypePolicySchema: GenMessage<StepTypePolicy> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 9);

/**
 * 步骤级容错
 *
 * @generated from message infinigence.infini.agentplatform.v1.StepFaultTolerance
 */
export type StepFaultTolerance = Message<"infinigence.infini.agentplatform.v1.StepFaultTolerance"> & {
  /**
   * 是否启用步骤级容错；默认 true
   * @gotags: json:"enabled,omitempty"
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * 按步骤类型独立配置的容错策略
   * @gotags: json:"policies,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.StepTypePolicy policies = 2;
   */
  policies: StepTypePolicy[];
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.StepFaultTolerance.
 * Use `create(StepFaultToleranceSchema)` to create a new message.
 */
export const StepFaultToleranceSchema: GenMessage<StepFaultTolerance> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 10);

/**
 * 任务级容错
 *
 * @generated from message infinigence.infini.agentplatform.v1.TaskFaultTolerance
 */
export type TaskFaultTolerance = Message<"infinigence.infini.agentplatform.v1.TaskFaultTolerance"> & {
  /**
   * 是否启用任务级容错；默认 true
   * @gotags: json:"enabled,omitempty"
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * 任务总超时（秒），≤ 168h（604800 秒）
   * @gotags: json:"total_timeout_seconds,omitempty"
   *
   * @generated from field: int32 total_timeout_seconds = 2 [json_name = "total_timeout_seconds"];
   */
  totalTimeoutSeconds: number;

  /**
   * 任务自动重试（从安全 checkpoint 恢复）；默认 false
   * @gotags: json:"retry_enabled,omitempty"
   *
   * @generated from field: bool retry_enabled = 3 [json_name = "retry_enabled"];
   */
  retryEnabled: boolean;

  /**
   * 最大重试次数，范围 1-10，默认 3
   * @gotags: json:"max_retries,omitempty"
   *
   * @generated from field: int32 max_retries = 4 [json_name = "max_retries"];
   */
  maxRetries: number;

  /**
   * 重试间隔（秒），范围 1-10，默认 3
   * @gotags: json:"retry_interval_seconds,omitempty"
   *
   * @generated from field: int32 retry_interval_seconds = 5 [json_name = "retry_interval_seconds"];
   */
  retryIntervalSeconds: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.TaskFaultTolerance.
 * Use `create(TaskFaultToleranceSchema)` to create a new message.
 */
export const TaskFaultToleranceSchema: GenMessage<TaskFaultTolerance> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 11);

/**
 * @generated from message infinigence.infini.agentplatform.v1.AskUserConfig
 */
export type AskUserConfig = Message<"infinigence.infini.agentplatform.v1.AskUserConfig"> & {
  /**
   * 是否启用 ask_user middleware；默认 false（不启用）。存量 Agent 无此字段时不开启。
   * @gotags: json:"enable,omitempty"
   *
   * @generated from field: bool enable = 1;
   */
  enable: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.AskUserConfig.
 * Use `create(AskUserConfigSchema)` to create a new message.
 */
export const AskUserConfigSchema: GenMessage<AskUserConfig> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 12);

/**
 * @generated from message infinigence.infini.agentplatform.v1.ReadBeforeWriteConfig
 */
export type ReadBeforeWriteConfig = Message<"infinigence.infini.agentplatform.v1.ReadBeforeWriteConfig"> & {
  /**
   * 是否启用 read_before_write middleware；默认 false（不启用）。
   * 启用后，对已存在文件的 write_file / edit_file 操作要求先读过当前版本，防止盲写覆盖。
   * 建议与 filesystem middleware 同时启用。存量 Agent 无此字段时不开启。
   * @gotags: json:"enable,omitempty"
   *
   * @generated from field: bool enable = 1;
   */
  enable: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.ReadBeforeWriteConfig.
 * Use `create(ReadBeforeWriteConfigSchema)` to create a new message.
 */
export const ReadBeforeWriteConfigSchema: GenMessage<ReadBeforeWriteConfig> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 13);

/**
 * web_search middleware 配置（Tavily 联网搜索 + 网页抓取工具）
 *
 * @generated from message infinigence.infini.agentplatform.v1.WebSearchConfig
 */
export type WebSearchConfig = Message<"infinigence.infini.agentplatform.v1.WebSearchConfig"> & {
  /**
   * 是否启用 web_search middleware；默认 false（不启用）。存量 Agent 无此字段时不开启。
   * @gotags: json:"enable,omitempty"
   *
   * @generated from field: bool enable = 1;
   */
  enable: boolean;

  /**
   * Tavily API Key；enable=true 时必填（framework 侧无全局兜底，缺失会导致工具调用失败）
   * @gotags: json:"tavily_api_key,omitempty"
   *
   * @generated from field: string tavily_api_key = 2 [json_name = "tavily_api_key"];
   */
  tavilyApiKey: string;

  /**
   * 单次搜索返回的最大结果数；0 或缺省时由 framework 默认（5）
   * @gotags: json:"max_results,omitempty"
   *
   * @generated from field: int32 max_results = 3 [json_name = "max_results"];
   */
  maxResults: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.WebSearchConfig.
 * Use `create(WebSearchConfigSchema)` to create a new message.
 */
export const WebSearchConfigSchema: GenMessage<WebSearchConfig> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 14);

/**
 * @generated from message infinigence.infini.agentplatform.v1.FaultToleranceConfig
 */
export type FaultToleranceConfig = Message<"infinigence.infini.agentplatform.v1.FaultToleranceConfig"> & {
  /**
   * 容错总开关；默认 true。缺省（存量 Agent）时平台不下发容错 middleware，运行时行为不变
   * @gotags: json:"enabled,omitempty"
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * 任务级容错
   * @gotags: json:"task,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.TaskFaultTolerance task = 2;
   */
  task?: TaskFaultTolerance | undefined;

  /**
   * 步骤级容错
   * @gotags: json:"step,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.StepFaultTolerance step = 3;
   */
  step?: StepFaultTolerance | undefined;

  /**
   * 是否开放给实例覆盖（走 instance_params）；默认 false
   * @gotags: json:"configurable,omitempty"
   *
   * @generated from field: bool configurable = 4;
   */
  configurable: boolean;

  /**
   * @gotags: json:"configurable_params,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Param configurable_params = 5 [json_name = "configurable_params"];
   */
  configurableParams: Param[];
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.FaultToleranceConfig.
 * Use `create(FaultToleranceConfigSchema)` to create a new message.
 */
export const FaultToleranceConfigSchema: GenMessage<FaultToleranceConfig> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 15);

/**
 * current_time middleware 配置（每次模型调用追加当前时间）
 *
 * @generated from message infinigence.infini.agentplatform.v1.CurrentTimeConfig
 */
export type CurrentTimeConfig = Message<"infinigence.infini.agentplatform.v1.CurrentTimeConfig"> & {
  /**
   * 是否启用 current_time middleware；默认 false（不启用）。存量 Agent 无此字段时不开启。
   * 时区与时间格式由 framework 默认（Asia/Shanghai）。
   * @gotags: json:"enable,omitempty"
   *
   * @generated from field: bool enable = 1;
   */
  enable: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.CurrentTimeConfig.
 * Use `create(CurrentTimeConfigSchema)` to create a new message.
 */
export const CurrentTimeConfigSchema: GenMessage<CurrentTimeConfig> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 16);

/**
 * HITL 参数匹配条件（对应 vibe-agent ArgMatch wire 契约）
 *
 * @generated from message infinigence.infini.agentplatform.v1.HITLArgMatch
 */
export type HITLArgMatch = Message<"infinigence.infini.agentplatform.v1.HITLArgMatch"> & {
  /**
   * 工具参数名（如 command）
   * @gotags: json:"argument,omitempty"
   *
   * @generated from field: string argument = 1;
   */
  argument: string;

  /**
   * 参数值需匹配的正则表达式
   * @gotags: json:"pattern,omitempty"
   *
   * @generated from field: string pattern = 2;
   */
  pattern: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.HITLArgMatch.
 * Use `create(HITLArgMatchSchema)` to create a new message.
 */
export const HITLArgMatchSchema: GenMessage<HITLArgMatch> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 17);

/**
 * HITL 工具匹配条件（对应 vibe-agent ToolMatch wire 契约）
 *
 * @generated from message infinigence.infini.agentplatform.v1.HITLToolMatch
 */
export type HITLToolMatch = Message<"infinigence.infini.agentplatform.v1.HITLToolMatch"> & {
  /**
   * 工具名列表（"*" 匹配全部工具）
   * @gotags: json:"tools,omitempty"
   *
   * @generated from field: repeated string tools = 1;
   */
  tools: string[];

  /**
   * 参数匹配条件（全部满足才算命中）
   * @gotags: json:"when,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.HITLArgMatch when = 2;
   */
  when: HITLArgMatch[];
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.HITLToolMatch.
 * Use `create(HITLToolMatchSchema)` to create a new message.
 */
export const HITLToolMatchSchema: GenMessage<HITLToolMatch> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 18);

/**
 * HITL 审批规则（对应 vibe-agent ApprovalRule wire 契约）
 *
 * @generated from message infinigence.infini.agentplatform.v1.HITLApprovalRule
 */
export type HITLApprovalRule = Message<"infinigence.infini.agentplatform.v1.HITLApprovalRule"> & {
  /**
   * 命中后的动作: deny | auto_approve | require_human
   * @gotags: json:"action,omitempty"
   *
   * @generated from field: string action = 1;
   */
  action: string;

  /**
   * 规则描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * 允许的人工决策动作（如 respond，用于 ask_user 类交互）
   * @gotags: json:"allowed_actions,omitempty"
   *
   * @generated from field: repeated string allowed_actions = 3 [json_name = "allowed_actions"];
   */
  allowedActions: string[];

  /**
   * 工具匹配条件
   * @gotags: json:"tool_match,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.HITLToolMatch tool_match = 4 [json_name = "tool_match"];
   */
  toolMatch?: HITLToolMatch | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.HITLApprovalRule.
 * Use `create(HITLApprovalRuleSchema)` to create a new message.
 */
export const HITLApprovalRuleSchema: GenMessage<HITLApprovalRule> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 19);

/**
 * HITL 审批 middleware 配置（对应 vibe-agent HITLMiddlewareConfig wire 契约，新增 enabled）
 *
 * @generated from message infinigence.infini.agentplatform.v1.HITLMiddlewareConfig
 */
export type HITLMiddlewareConfig = Message<"infinigence.infini.agentplatform.v1.HITLMiddlewareConfig"> & {
  /**
   * 是否启用（framework FeatureGate 默认 false，需显式开启才会实例化）
   * @gotags: json:"enabled,omitempty"
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * 无规则命中时的默认行为: require_human | deny | auto_approve（留空使用 vibe-agent 默认 auto_approve）
   * @gotags: json:"default_action,omitempty"
   *
   * @generated from field: string default_action = 2 [json_name = "default_action"];
   */
  defaultAction: string;

  /**
   * 审批规则列表（先匹配先生效，deny 规则应排在前面）
   * @gotags: json:"rules,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.HITLApprovalRule rules = 3;
   */
  rules: HITLApprovalRule[];

  /**
   * 触发人工审批时是否调用 LLM 生成一句中文意图描述
   * @gotags: json:"enable_desc,omitempty"
   *
   * @generated from field: bool enable_desc = 4 [json_name = "enable_desc"];
   */
  enableDesc: boolean;

  /**
   * 意图描述使用的模型名，留空使用 vibe-agent 默认模型
   * @gotags: json:"desc_model,omitempty"
   *
   * @generated from field: string desc_model = 5 [json_name = "desc_model"];
   */
  descModel: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.HITLMiddlewareConfig.
 * Use `create(HITLMiddlewareConfigSchema)` to create a new message.
 */
export const HITLMiddlewareConfigSchema: GenMessage<HITLMiddlewareConfig> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 20);

/**
 * 智能体高级配置
 *
 * @generated from message infinigence.infini.agentplatform.v1.AgentAdvancedConfig
 */
export type AgentAdvancedConfig = Message<"infinigence.infini.agentplatform.v1.AgentAdvancedConfig"> & {
  /**
   * 压缩配置
   * @gotags: json:"compression,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.CompressionConfig compression = 1;
   */
  compression?: CompressionConfig | undefined;

  /**
   * 工具权限规则（Agent 级别），优先级高于 ChannelUserBinding 级别
   * @gotags: json:"tool_permissions,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ToolPermissions tool_permissions = 2 [json_name = "tool_permissions"];
   */
  toolPermissions?: ToolPermissions | undefined;

  /**
   * 沙箱微应用功能，选择指定 Plugin 的沙箱，作为微应用运行环境
   * @gotags: json:"sandbox_micro_app,omitempty"
   *
   * @generated from field: string sandbox_micro_app = 3 [json_name = "sandbox_micro_app"];
   */
  sandboxMicroApp: string;

  /**
   * filesystem middleware 配置
   * @gotags: json:"filesystem,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.FilesystemConfig filesystem = 4;
   */
  filesystem?: FilesystemConfig | undefined;

  /**
   * todo_list middleware 配置
   * @gotags: json:"todo_list,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.TodoListConfig todo_list = 5 [json_name = "todo_list"];
   */
  todoList?: TodoListConfig | undefined;

  /**
   * ask_user middleware 配置（向用户提问的人工介入工具）
   * @gotags: json:"ask_user,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.AskUserConfig ask_user = 6 [json_name = "ask_user"];
   */
  askUser?: AskUserConfig | undefined;

  /**
   * read_before_write middleware 配置（写前必须读版本门控）
   * @gotags: json:"read_before_write,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ReadBeforeWriteConfig read_before_write = 7 [json_name = "read_before_write"];
   */
  readBeforeWrite?: ReadBeforeWriteConfig | undefined;

  /**
   * web_search middleware 配置（Tavily 联网搜索 + 网页抓取工具）
   * @gotags: json:"web_search,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.WebSearchConfig web_search = 8 [json_name = "web_search"];
   */
  webSearch?: WebSearchConfig | undefined;

  /**
   * current_time middleware 配置（每次模型调用追加当前时间）
   * @gotags: json:"current_time,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.CurrentTimeConfig current_time = 9 [json_name = "current_time"];
   */
  currentTime?: CurrentTimeConfig | undefined;

  /**
   * 容错配置
   * @gotags: json:"fault_tolerance,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.FaultToleranceConfig fault_tolerance = 10 [json_name = "fault_tolerance"];
   */
  faultTolerance?: FaultToleranceConfig | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.AgentAdvancedConfig.
 * Use `create(AgentAdvancedConfigSchema)` to create a new message.
 */
export const AgentAdvancedConfigSchema: GenMessage<AgentAdvancedConfig> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_agent, 21);

/**
 * filesystem middleware 可启用的工具，对应 infini-agent-framework FsToolName
 *
 * @generated from enum infinigence.infini.agentplatform.v1.FilesystemTool
 */
export enum FilesystemTool {
  /**
   * 未指定：生成 middleware 配置时跳过该值
   *
   * @generated from enum value: FILESYSTEM_TOOL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 列出目录
   *
   * @generated from enum value: FILESYSTEM_TOOL_LS = 1;
   */
  LS = 1,

  /**
   * 读取文件
   *
   * @generated from enum value: FILESYSTEM_TOOL_READ_FILE = 2;
   */
  READ_FILE = 2,

  /**
   * 写文件
   *
   * @generated from enum value: FILESYSTEM_TOOL_WRITE_FILE = 3;
   */
  WRITE_FILE = 3,

  /**
   * 编辑文件
   *
   * @generated from enum value: FILESYSTEM_TOOL_EDIT_FILE = 4;
   */
  EDIT_FILE = 4,

  /**
   * 删除文件/目录
   *
   * @generated from enum value: FILESYSTEM_TOOL_DELETE = 5;
   */
  DELETE = 5,

  /**
   * glob 匹配
   *
   * @generated from enum value: FILESYSTEM_TOOL_GLOB = 6;
   */
  GLOB = 6,

  /**
   * grep 检索
   *
   * @generated from enum value: FILESYSTEM_TOOL_GREP = 7;
   */
  GREP = 7,

  /**
   * 执行命令
   *
   * @generated from enum value: FILESYSTEM_TOOL_EXECUTE = 8;
   */
  EXECUTE = 8,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.FilesystemTool.
 */
export const FilesystemToolSchema: GenEnum<FilesystemTool> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_agent, 0);

/**
 * 步骤类型（容错策略按步骤类型独立配置）
 *
 * @generated from enum infinigence.infini.agentplatform.v1.StepType
 */
export enum StepType {
  /**
   * 未指定
   *
   * @generated from enum value: STEP_TYPE_UNSPECIFIED = 0;
   */
  STEP_TYPE_UNSPECIFIED = 0,

  /**
   * 模型调用步骤
   *
   * @generated from enum value: MODEL = 1;
   */
  MODEL = 1,

  /**
   * 工具调用步骤
   *
   * @generated from enum value: TOOL = 2;
   */
  TOOL = 2,

  /**
   * 子 Agent 步骤
   *
   * @generated from enum value: SUBAGENT = 3;
   */
  SUBAGENT = 3,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.StepType.
 */
export const StepTypeSchema: GenEnum<StepType> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_agent, 1);

